import type { BrandMembership, BrandRecord } from './brandGroupViewModel';

type MemberBusinessGroupInput = {
  memberId: string | number;
  memberStatus?: string | null;
  businessGroups: readonly BrandRecord[];
  memberships: readonly BrandMembership[];
};

/**
 * Resolve the Business groups visible to the current viewer for one active
 * Workspace member. The default group is implicit; every other group needs an
 * active persisted membership.
 */
export const getMemberBusinessGroups = ({
  memberId,
  memberStatus,
  businessGroups,
  memberships,
}: MemberBusinessGroupInput): BrandRecord[] => {
  const normalizedMemberId = String(memberId || '').trim();
  const normalizedStatus = String(memberStatus || '')
    .trim()
    .toUpperCase();

  if (!normalizedMemberId || normalizedStatus !== 'ACTIVE') {
    return [];
  }

  const explicitBusinessGroupIds = new Set(
    memberships
      .filter(
        (membership) =>
          String(membership.userId) === normalizedMemberId &&
          membership.status !== 'INACTIVE',
      )
      .map((membership) => membership.brandId),
  );

  return businessGroups
    .filter(
      (businessGroup) =>
        businessGroup.isDefault === true ||
        explicitBusinessGroupIds.has(businessGroup.id),
    )
    .sort(
      (first, second) =>
        Number(second.isDefault === true) - Number(first.isDefault === true),
    );
};
